import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReceiptIcon(props: IconProps) {
    return <Icon {...props} iconKey={"receipt"}/>
}
